import { useState, useEffect } from "react";
import Image from "./Image";
import './ImageCarousel.css';
import ArrowLeft from "../common/ArrowLeft";
import ArrowRight from "../common/ArrowRight";
import { useSwipe } from "../utils/useSwipe";

// ImageCarousel component to display images in an organized manner

function ImageCarousel({ images, onImageClick, className = "" }) {

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const {handleTouchStart, handleTouchEnd, handleNext, handlePrev} = useSwipe(images, setCurrentImageIndex)

    // Reset the image index if images change
    useEffect(() => {
        setCurrentImageIndex(0);
    }, [images]);

    // Only return layout if images exist in the first place
    if (!images || images.length === 0) return null;

    // Render the dots indicating the number of images in the carousel
    const renderDots = (extraClass = "") => (
        <div className={`CarouselDots ${extraClass}`}>
            {images.map((_, i) => (
                <span
                    key={i}
                    className={`dot ${i === currentImageIndex ? "active" : ""}`}
                    onClick={() => setCurrentImageIndex(i)}
                />
            ))}
        </div>
    );

    return (
        <div className={`ImageCarouselWrapper ${className}`}>

            {/* On devices with wider screens (>768px), the nav buttons are displayed next to the carousel. On smaller
                screens, they are displayed next to the dots underneath the carousel */}
            <div
                className="ImageCarousel"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                {images.length > 1 && (
                    <button className="ImageNavButton left desktop-only" onClick={handlePrev}>
                        <ArrowLeft />
                    </button>
                )}

                <Image
                    className="CarouselImage"
                    img={images[currentImageIndex]}
                    alt={`Image ${currentImageIndex}`}
                    onClick={() => onImageClick?.(currentImageIndex)}
                />

                {images.length > 1 && (
                    <button
                        className="ImageNavButton right desktop-only"
                        onClick={handleNext}
                    >
                        <ArrowRight />
                    </button>
                )}
            </div>

            {images.length > 1 && (
                <div className="CarouselControls">
                    {renderDots("desktop-only")}
                    <div className="ImageNavControls mobile-only" role="group" aria-label="Bildnavigation">
                        <button className="ImageNavButton left" onClick={handlePrev}>
                            <ArrowLeft />
                        </button>
                            {renderDots("mobile-only")}
                        <button className="ImageNavButton right" onClick={handleNext}>
                            <ArrowRight />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ImageCarousel;